export const resetData = {
  reset_title: 'Réinitialiser toutes les données de cette étude',
  resret_text: 'Voulez-vous vraiment réinitialiser toutes les données de cette étude ? Cette action ne peut pas être annulée.'
};
